import { Guid } from "guid-typescript";

import { AggregateDataFieldValue } from "lib/data/model";
import { UniField } from "./UniField";

export class MultiField {

	public readonly name: string = Guid.create().toString();
	public value: AggregateDataFieldValue;
	public fields: Array<UniField | MultiField> = [];

	constructor(newValue: AggregateDataFieldValue, newFields: Array<UniField | MultiField> = []) {

		this.value = newValue;
		this.fields = newFields;
	}
}
